import React from 'react';

import { planActionTypes } from './actions'
import moment from 'moment'


export function plans(state = {
    isFetching: false,
    key: null,
    data: [],
}, action) {

    switch (action.type) {
        case planActionTypes.REQUEST:
            
            state = { ...state }
            state.isFetching = true
            return state

        case planActionTypes.RECEIVE:

            state = { ...state }

            state.isFetching = false
            state.data = action.data.results

            return state

        default:
            return state
    }

}